/* eslint-disable react/prop-types */
import { React, useState } from 'react';
import PropTypes from 'prop-types';
import { HeaderButtonMaker } from './HeaderButtonMaker';
import { Menu, MenuItem } from '@material-ui/core';
import { AnnouncementDialog } from './AnnouncementDialog';
import { connect } from 'react-redux';

/**
 * @param {function} buttonHandler custom handler for this button (Required)
 * @param {Number} rotate Number ex: to rotate 90degree give 90
 * @param {String} tooltip String, tooltip text to be displayed under button
 */
export const AddButton = ({ buttonHandler, id, rotate, tooltip }) => (
    <HeaderButtonMaker
        id={id}
        buttonHandler={buttonHandler}
        rotate={rotate}
        tooltip={tooltip}
        className="icon"
        fontSize="large"
        iconType="add"
    />
);

AddButton.propTypes = {
    buttonHandler: PropTypes.func.isRequired,
    id: PropTypes.string,
    rotate: PropTypes.number,
    tooltip: PropTypes.string,
};

/**
 * @param {function} buttonHandler custom handler for this button (Required)
 * @param {String} tooltip String, tooltip text to be displayed under button
 */
const InformationButtonComponent = ({ buttonHandler, id, tooltip, isMRATOnline }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [clickedButton, setClickedButton] = useState(null);

    const handleClick = (event) => {
        if (!isMRATOnline) {
            buttonHandler();
        } else {
            setAnchorEl(event.currentTarget);
        }
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleOptionClick = (option) => {
        if (option === 'UserGuide') {
            buttonHandler();
        } else if (option === 'Announcements') {
            setClickedButton(option);
        }
        setDialogOpen(true);
        handleClose();
    };

    const handleDialogClose = () => {
        setDialogOpen(false);
    };
    return (
        <div>
            <HeaderButtonMaker
                id={id || 'InformationButton'}
                buttonHandler={handleClick}
                tooltip={tooltip}
                className="icon"
                fontSize="large"
                iconType="info"
            />
            {isMRATOnline && (
                <Menu
                    id="information-button-menu"
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    style={{ marginTop: '40px' }}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'center',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                >
                    <MenuItem style={{ fontSize: '9pt' }} onClick={() => handleOptionClick('UserGuide')}>User Guide</MenuItem>
                    <MenuItem style={{ fontSize: '9pt' }} onClick={() => handleOptionClick('Announcements')}>Announcements</MenuItem>
                </Menu>
            )}
            {isMRATOnline && clickedButton === 'Announcements' && (
                <AnnouncementDialog open={dialogOpen} onClose={handleDialogClose} />
            )}
        </div>
    );
};

InformationButtonComponent.propTypes = {
    buttonHandler: PropTypes.func.isRequired,
    id: PropTypes.string,
    isMRATOnline: PropTypes.bool,
    tooltip: PropTypes.string
};

const mapStateToProps = ({ AppData, Home }) => ({
    isMRATOnline: AppData.isMRATOnline,
});
export const InformationButton = connect(mapStateToProps)(InformationButtonComponent);

InformationButton.propTypes = {
    buttonHandler: PropTypes.func.isRequired,
    id: PropTypes.string,
    tooltip: PropTypes.string,
};

export const AccountButton = ({ buttonHandler, id, tooltip }) => (
    <HeaderButtonMaker
        id={id || 'accountButton'}
        buttonHandler={buttonHandler}
        tooltip={tooltip}
        className="icon"
        fontSize="large"
        iconType="account"
    />
);

AccountButton.propTypes = {
    buttonHandler: PropTypes.func.isRequired,
    id: PropTypes.string,
    tooltip: PropTypes.string,
};

export const PrintButton = ({ buttonHandler, id, tooltip }) => (
    <HeaderButtonMaker
        id={id || 'PrintButton'}
        buttonHandler={buttonHandler}
        tooltip={tooltip}
        className="icon"
        fontSize="medium"
        iconType="print"
    />
);

PrintButton.propTypes = {
    buttonHandler: PropTypes.func.isRequired,
    id: PropTypes.string,
    tooltip: PropTypes.string,
};

export const PaletteButton = ({ buttonHandler, id, tooltip }) => (
    <HeaderButtonMaker
        id={id || 'PaletteButton'}
        buttonHandler={buttonHandler}
        tooltip={tooltip}
        className="icon"
        fontSize="large"
        iconType="palette"
    />
);

PaletteButton.propTypes = {
    buttonHandler: PropTypes.func.isRequired,
    id: PropTypes.string,
    tooltip: PropTypes.string,
};
